export default __webpack_public_path__ + "static/media/Login2.f8497aa8.png";